/**
 * Category name → URL slug for /category/:slug landing pages.
 * Mirrors categorySlug() in lib/categoryPages.js on the server; keep them identical.
 *   "Clothing, Shoes & Jewelry" → "clothing-shoes-and-jewelry"
 */
export const categorySlug = (name) => String(name || '')
  .toLowerCase()
  .replace(/&/g, ' and ')
  .replace(/[^a-z0-9]+/g, '-')
  .replace(/^-+|-+$/g, '');

/** URL of the category's landing page, or null when that category has none. */
export const categoryPath = (name, categoryPages = []) => {
  const slug = categorySlug(name);
  return categoryPages.some((c) => c.slug === slug) ? `/category/${slug}` : null;
};

/**
 * Heading, intro line and <title> of a category page. Same text as
 * categoryIntro()/categoryHead() in lib/pageRoutes.js, which the server renders first.
 */
export const categoryIntro = ({ name, maxPercentOff }) => ({
  title: `${name} Deals`,
  text: `Today's best Amazon ${name} deals and promo codes${maxPercentOff > 0 ? `, up to ${maxPercentOff}% off` : ''}. Checked every hour; expired deals are removed automatically.`,
});

export const categoryTitle = ({ name, maxPercentOff }) => (
  `${name} Deals Today${maxPercentOff > 0 ? `: Up to ${maxPercentOff}% Off` : ''} | Lite Pocket Deals`
);
